import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TextInput, Alert, FlatList, TouchableOpacity } from 'react-native';
import defaultStyles from "../config/styles";
import { FontAwesome5 } from "@expo/vector-icons";
import colors from '../config/colors';
import connectionConfig from "../config/settings";
import configurationPost from '../config/configurationPost';
//import settingStorage from "../config/settingStorage";
import { ListItemSearch, ListItemSeparator, NotificationListItem } from "../components/lists";
import routes from '../navigation/routes';
import ActivityIndicator from '../components/ActivityIndicator';
import Icon from '../components/Icon';

var seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'
var webUrl = connectionConfig.imageUrl + '/seedImages/'

var pointer = 0
var blockSize = 15
var pageNumber = 0
var arraySeeds = []
var textPagination = ''

function SearchSeedScreen(props) {

  useEffect(() => {
    console.log(props.route.params)
    pageNumber = 0
    arraySeeds = []
    pointer = 0
  }, []);

  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false);

  //----------------------------------------------------
  //servicio de busqueda cuando se teclea el campo input
  //----------------------------------------------------
  const onChangeText = async (text) => {
    setItems([])
    pageNumber = 0
    arraySeeds = []
    pointer = 0
    textPagination = text.nativeEvent.text
    setLoading(true)
    var post_values = {
      textUser: text.nativeEvent.text,
      pointer,
      blockSize
    }
    configurationPost.body = JSON.stringify(post_values)
    //solicita el servicio para login fixo remoto
    if (props.route.params === "Por título") {
      await fetch(connectionConfig.apiUrl + '/selectSearchSeedName/', configurationPost)
        .then(response => response.json())
        .then(response => {
          //  debugger
          console.log('service -> /selectSearchSeedName/')
          if (response.data.length === 0) {
            setLoading(false)
            Alert.alert("Notification", "Name doesn't exists in fixo.");
          } else {
            setLoading(false)
            setItems(response.data)
          }
        })
        .catch(err => {
          console.log('searchUser failed :( review internet service /selectSearchSeedName/', err)
        })
    } if (props.route.params === "Por descripción"){
      await fetch(connectionConfig.apiUrl + '/selectSearchSeedDescription/', configurationPost)
        .then(response => response.json())
        .then(response => {
          //  debugger
          console.log('service -> /selectSearchSeedDescription/')
          if (response.data.length === 0) {
            setLoading(false)
            Alert.alert("Notification", "Description doesn't exists in fixo.");
          } else {
            setLoading(false)
            setItems(response.data)
          }
        })
        .catch(err => {
          console.log('searchUser failed :( review internet service /selectSearchSeedDescription/', err)
        })
    }
  }

  //---------------------------------------------
  //servicio de paginacion de la busqueda
  //---------------------------------------------
  const paginationList = async (text) => {
    //  debugger
    pointer = pageNumber * blockSize
    setLoading(true)
    var post_values = {
      textUser: textPagination,
      pointer: pointer,
      blockSize: blockSize
    }
    configurationPost.body = JSON.stringify(post_values)
    if (props.route.params === "Por título") {
      await fetch(connectionConfig.apiUrl + '/selectSearchSeedName/', configurationPost)
        .then(response => response.json())
        .then(response => {
          if (response.data.length === 0) {
            if (pageNumber > 0) {
              setLoading(false)
            } else {
              setLoading(false)
            }
          } else {
            pageNumber++
            if (arraySeeds.length > 0) {
              arraySeeds = [...arraySeeds, ...response.data]
            } else {
              arraySeeds = response.data
            }
            setItems(arraySeeds)
            setLoading(false)
          }
        })
        .catch(err => {
          console.log('failed :( review internet service -> /selectSearchSeedName/', err)
        })
    }  
    if (props.route.params === "Por descripción"){
      await fetch(connectionConfig.apiUrl + '/selectSearchSeedDescription/', configurationPost)
        .then(response => response.json())
        .then(response => {

          if (response.data.length === 0) {
            if (pageNumber > 0) {
              setLoading(false)
            } else {
              setLoading(false)
            }
          } else {
            pageNumber++
            if (arraySeeds.length > 0) {
              arraySeeds = [...arraySeeds, ...response.data]
            } else {
              arraySeeds = response.data
            }
            setItems(arraySeeds)
            setLoading(false)
          }
        })
        .catch(err => {
          console.log('failed :( review internet service -> /selectSearchSeedDescription/', err)
        })
    }
  }

  return (
    <View style={styles.container}>
      <ListItemSearch
        IconComponent={
          props.route.params === "Por título" ?
            <Icon
              iconFamily={"MaterialIcons"}
              name={'search'}
              backgroundColor={colors.pistache}
              iconColor={colors.green}
            />
            :
            <Icon
              iconFamily={"MaterialIcons"}
              name={'search'}
              backgroundColor={colors.fuente}
            //iconColor={colors.green}
            />
        }
        title={props.route.params}
      />
      <View style={styles.containerSearch}>
      <FontAwesome5
      color={colors.green}
                style={styles.icon}
                name={"seedling"}
                size={33}
              />
        <TextInput style={styles.input}
          onChange={text => onChangeText(text)}
        ></TextInput>
      </View>

      <ActivityIndicator visible={loading} />

      <FlatList
        data={items}
        keyExtractor={(items) => items.seedId.toString()}
        ItemSeparatorComponent={ListItemSeparator}
        onEndReachedThreshold={.5}
        onEndReached={() => paginationList()}
        renderItem={({ item, index }) => (
          item.seedPhoto === null ?
            null :
            item.seedPhoto.includes('mp4') ?
              <ListItemSearch
                IconComponent={
                  <Icon
                    name={'video'}
                    backgroundColor={'black'}
                    size={70}
                  />
                }
                //image={webUrl + item.seedPhoto}
                title={item.seedName}
                subTitle={item.seedDescription}
                onPress={() => {
                  var screen = 'ListingsSeedsScreen'//{screen: 'ListingsSeedsScreen'}
                  props.navigation.navigate(routes.SEED_DETAILS, { item, screen, screen })

                }}
              />
              : item.seedPhoto.includes('mov') ?
                <ListItemSearch
                  IconComponent={
                    <Icon
                      name={'video'}
                      backgroundColor={'black'}
                      size={70}
                    />
                  }
                  //image={webUrl + item.seedPhoto}
                  title={item.seedName}
                  subTitle={item.seedDescription}
                  onPress={() => {
                    var screen = 'ListingsSeedsScreen'//{screen: 'ListingsSeedsScreen'}
                    props.navigation.navigate(routes.SEED_DETAILS, { item, screen, screen })

                  }}
                />
                : item.seedPhoto === '' ?
                  <ListItemSearch
                    IconComponent={
                      <Icon
                        name={'mountains'}
                        backgroundColor={'black'}
                        size={70}
                        iconFamily={'Foundation'}
                      />
                    }
                    //image={webUrl + item.seedPhoto}
                    title={item.seedName}
                    subTitle={item.seedDescription}
                    onPress={() => {
                      var screen = 'ListingsSeedsScreen'//{screen: 'ListingsSeedsScreen'}
                      props.navigation.navigate(routes.SEED_DETAILS, { item, screen, screen })
                    }}
                  />
                  :
                  <ListItemSearch
                    // image={webUrl + item.seedPhoto} :null
                    image={webUrl + item.seedPhoto}
                    title={item.seedName}
                    subTitle={item.seedDescription}
                    onPress={() => {
                      console.log('hola fotirri ->', webUrl + item.seedPhoto)
                      var screen = 'ListingsSeedsScreen'//{screen: 'ListingsSeedsScreen'}
                      props.navigation.navigate(routes.SEED_DETAILS, { item, screen, screen })

                    }}
                  />

        )}>
      </FlatList>

    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    // marginLeft: '20%',
    // marginRight:'20%'
  },
  containerSearch: {
    marginTop: "1%",
   // marginBottom: "5%",
    //position:'absolute',
    flexDirection: "row",
    width: "100%",
    height: "10%"
  },
  input: {
    borderWidth: 1,
    borderColor: colors.medium,
    paddingLeft: 5,
    borderRadius: 5,
    width: "80%",
    marginLeft:'15%',
    //position:'absolute',
  },
  icon: {
    position:'absolute',
    alignSelf: "center",
    marginLeft: 15,
    //width: "10%",
  }
})

export default SearchSeedScreen;